import React from 'react';
import s from './s.module.less';
import Icon from './icon.png';
import { Button } from 'antd';
import { disconnetFromGoogle } from 'api/provider';
import useGoogleAuthStatus from 'hooks/useGoogleAuthStatus';

interface DisconnectBannerProps {
    onUpdate: () => void;
}

const DisconnectBanner = ({ onUpdate }: DisconnectBannerProps) => {
    const [authStatus] = useGoogleAuthStatus();

    const onDisconnect = async () => {
        try {
            await disconnetFromGoogle();
            onUpdate();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className={s.wrap}>
            <div className={s.left}>
                <img src={Icon} width={50} height={50} />
                <div className={s.info}>
                    <div className={s.title}>
                        Google Calendar
                    </div>
                    <div className={s.des}>
                        {authStatus?.email}
                    </div>
                </div>
            </div>
            <div className={s.right}>
                <Button onClick={onDisconnect}>Disconnect</Button>
            </div>
        </div>
    );
};

export default DisconnectBanner;
